import React from 'react';
import { Box, VStack, Heading, Text } from '@companydotcom/potion';
import { FontAwesomeIcon } from '@companydotcom/ui';
import { faGlasses } from '@fortawesome/pro-thin-svg-icons';
import { useTranslation } from 'react-i18next';

export const FaceCakeContentReviewTile = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <VStack spacing="2">
        <FontAwesomeIcon icon={faGlasses} color="pink.500" boxSize={{ base: '12', xl: '16' }} />
        <Heading size="lg" color="pink.500" fontWeight="bold">
          {t('icommerce.tileStatus.review.header')}
        </Heading>
        <Text>{t('icommerce.tileStatus.review.body')}</Text>
      </VStack>
    </Box>
  );
};
